import {client} from '../helpers/api';

export async function getAppSettings() {
  const response = await client.get('/v1/settings');
  if (response.data?.status) {
    return response.data?.data || null;
  }
  throw response;
}
